var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewAxisAlternates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 57,
    viewBox: "0 0 215 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9004 51.003H90.9749L93.9876 56.2045H98.9132L95.9004 51.003ZM82.8857 56.2045H87.8922L90.905 51.003L93.3586 46.6917L90.9749 42.5056L82.8857 56.2045Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.271 49.7046H150.803L150.188 50.8781H149.225L152.042 45.8017L154.776 50.8781H153.882L153.267 49.7046H153.271ZM152.936 49.0204L152.042 47.3761L151.148 49.0204H152.933H152.936Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.001 49.7046H162.533L161.919 50.8781H160.955L163.758 45.8017L166.506 50.8781H165.612L164.998 49.7046H165.001ZM164.652 49.0204L163.758 47.3761L162.864 49.0204H164.648H164.652Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.385 49.7046H99.917L99.3026 50.8781H98.3389L101.157 45.8017L103.89 50.8781H102.996L102.382 49.7046H102.385ZM102.051 49.0204L101.157 47.3761L100.263 49.0204H102.047H102.051Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.932 48.41L104.354 46.0778H105.388L106.488 47.7258L107.646 46.0778H108.61L106.962 48.41L108.68 50.8783H107.716L106.418 49.0243L105.108 50.8783H104.159L105.932 48.41Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.199 46.0778H109.375V50.8746H110.199V46.0778Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.51 46.7619L113.826 47.1114C113.686 46.9017 113.561 46.7619 113.421 46.692C113.351 46.6221 113.141 46.6221 112.932 46.6221C112.737 46.6221 112.527 46.692 112.387 46.7619C112.178 46.9017 112.108 47.0415 112.108 47.1813C112.108 47.4461 112.317 47.6558 112.737 47.7956L113.351 47.9906C113.826 48.1303 114.105 48.34 114.385 48.5497C114.58 48.7447 114.65 49.0242 114.65 49.3737C114.65 49.7783 114.51 50.1977 114.175 50.4625C113.756 50.7421 113.351 50.8819 112.807 50.8819C112.317 50.8819 111.913 50.812 111.567 50.5324C111.302 50.2529 111.092 49.9181 111.022 49.4988L111.846 49.3038C111.916 49.5687 111.986 49.7783 112.056 49.9181C112.251 50.1278 112.531 50.1977 112.865 50.1977C113.145 50.1977 113.355 50.1278 113.564 49.988C113.689 49.8482 113.829 49.6385 113.829 49.4436C113.829 49.3038 113.759 49.2339 113.759 49.164C113.689 49.0941 113.689 49.0242 113.634 48.9543C113.564 48.8844 113.494 48.8145 113.355 48.7447C113.285 48.6748 113.145 48.6895 113.005 48.6196L112.461 48.4099C111.637 48.1303 111.232 47.7257 111.232 47.1813C111.232 46.8318 111.427 46.5522 111.777 46.2874C112.056 46.0777 112.461 45.9379 113.005 45.9379C113.634 45.9379 114.179 46.2175 114.513 46.7619H114.51Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.353 50.8084H189.203V47.3616C189.358 47.5566 189.538 47.7258 189.747 47.8914L193.415 50.8048V45.7541H192.576V49.1862C192.381 48.9912 192.186 48.7963 191.947 48.616L188.35 45.7578V50.8084H188.353Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.313 48.3656L182.927 50.8781H183.791L182.423 45.8017L180.779 48.7593C180.694 48.9138 180.569 49.1234 180.459 49.3883C180.304 49.0535 180.194 48.8439 180.153 48.7593L178.48 45.8017L177.141 50.8781H177.99L178.605 48.3656C178.645 48.156 178.689 47.9463 178.704 47.7256C178.774 47.9353 178.873 48.1302 178.984 48.3252L180.462 50.8781L181.941 48.3656C182.081 48.156 182.166 47.9463 182.206 47.7256C182.261 48.075 182.291 48.2847 182.316 48.3656H182.313Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M173.426 50.8777H176.578V50.1531H174.334V48.5492H176.578V47.8503H174.334V46.6106H176.578V45.9264H173.426V50.8777Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184.348 50.8777H187.5V50.1531H185.271V48.5492H187.5V47.8503H185.271V46.6106H187.5V45.9264H184.348V50.8777Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M170.009 48.2698V48.9393H171.418V49.0092C171.418 49.7191 170.763 50.1679 169.674 50.1679C168.405 50.1679 167.526 49.4285 167.526 48.3397C167.526 47.2508 168.42 46.5261 169.659 46.5261C170.274 46.5261 170.763 46.7064 171.153 47.0853L171.852 46.6512C171.292 46.081 170.568 45.8125 169.648 45.8125C168.784 45.8125 168.004 46.0626 167.43 46.5114C166.845 46.986 166.536 47.615 166.536 48.3397C166.536 49.0643 166.841 49.7081 167.386 50.1679C167.956 50.6424 168.695 50.8779 169.645 50.8779C171.348 50.8779 172.337 50.098 172.337 48.7296C172.337 48.6192 172.323 48.4647 172.323 48.2698H170.009Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.335 50.9477H156.185V47.4899C156.339 47.6849 156.519 47.8541 156.729 48.0196L160.397 50.9477V45.886H159.547V49.3181C159.367 49.1232 159.157 48.9282 158.933 48.748L155.335 45.8897V50.9514V50.9477Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.371 48.3656L148 50.8781H148.85L147.481 45.8017L145.848 48.7593C145.764 48.9138 145.624 49.1234 145.513 49.3883C145.359 49.0535 145.263 48.8439 145.208 48.7593L143.534 45.8017L142.195 50.8781H143.045L143.659 48.3656C143.715 48.156 143.759 47.9463 143.759 47.7256C143.829 47.9353 143.924 48.1302 144.038 48.3252L145.517 50.8781L147.011 48.3656C147.136 48.156 147.22 47.9463 147.261 47.7256C147.316 48.075 147.345 48.2847 147.371 48.3656Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M138.152 46.6106H139.642V45.9264H135.725V46.6106H137.229V50.8777H138.152V46.6106Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M196.288 46.6106H197.782V45.9264H193.86V46.6106H195.369V50.8777H196.288V46.6106Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.112 50.8777H135.28V50.1531H133.032V48.5492H135.28V47.8503H133.032V46.6106H135.28V45.9264H132.112V50.8777Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.014 49.7046H119.546L118.932 50.8781H117.968L120.786 45.8017L123.519 50.8781H122.625L122.01 49.7046H122.014ZM121.679 49.0204L120.786 47.3761L119.892 49.0204H121.676H121.679Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.23 46.7619L126.532 47.1114C126.406 46.9017 126.267 46.7619 126.127 46.692C126.057 46.6221 125.847 46.6221 125.652 46.6221C125.443 46.6221 125.233 46.692 125.093 46.7619C124.898 46.9017 124.828 47.0415 124.828 47.1813C124.828 47.4461 125.023 47.6558 125.443 47.7956L126.057 47.9906C126.532 48.1303 126.811 48.34 127.091 48.5497C127.286 48.7447 127.356 49.0242 127.356 49.3737C127.356 49.7783 127.23 50.1977 126.881 50.4625C126.476 50.7421 126.057 50.8819 125.513 50.8819C125.023 50.8819 124.619 50.812 124.273 50.5324C124.008 50.2529 123.798 49.9181 123.729 49.4988L124.553 49.3038C124.622 49.5687 124.692 49.7783 124.762 49.9181C124.972 50.1278 125.237 50.1977 125.586 50.1977C125.851 50.1977 126.061 50.1278 126.27 49.988C126.41 49.8482 126.535 49.6385 126.535 49.4436C126.535 49.3038 126.48 49.2339 126.48 49.164C126.41 49.0941 126.41 49.0242 126.34 48.9543C126.27 48.8844 126.2 48.8145 126.061 48.7447C125.991 48.6748 125.851 48.6895 125.726 48.6196L125.167 48.4099C124.343 48.1303 123.938 47.7257 123.938 47.1813C123.938 46.8318 124.148 46.5522 124.483 46.2874C124.762 46.0777 125.167 45.9379 125.722 45.9379C126.337 45.9379 126.881 46.2175 127.23 46.7619Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.303 46.7619L130.618 47.1114C130.479 46.9017 130.339 46.7619 130.199 46.692C130.129 46.6221 129.934 46.6221 129.724 46.6221C129.515 46.6221 129.305 46.692 129.18 46.7619C128.97 46.9017 128.9 47.0415 128.9 47.1813C128.9 47.4461 129.11 47.6558 129.515 47.7956L130.129 47.9906C130.618 48.1303 130.883 48.34 131.163 48.5497C131.372 48.7447 131.442 49.0242 131.442 49.3737C131.442 49.7783 131.303 50.1977 130.953 50.4625C130.548 50.7421 130.129 50.8819 129.585 50.8819C129.11 50.8819 128.691 50.812 128.356 50.5324C128.076 50.2529 127.867 49.9181 127.797 49.4988L128.621 49.3038C128.691 49.5687 128.761 49.7783 128.831 49.9181C129.04 50.1278 129.305 50.1977 129.655 50.1977C129.934 50.1977 130.129 50.1278 130.339 49.988C130.479 49.8482 130.618 49.6385 130.618 49.4436C130.618 49.3038 130.548 49.2339 130.548 49.164C130.479 49.0941 130.479 49.0242 130.409 48.9543C130.339 48.8844 130.269 48.8145 130.129 48.7447C130.059 48.6748 129.934 48.6895 129.794 48.6196L129.235 48.4099C128.426 48.1303 128.007 47.7257 128.007 47.1813C128.007 46.8318 128.216 46.5522 128.551 46.2874C128.831 46.0777 129.235 45.9379 129.791 45.9379C130.405 45.9379 130.949 46.2175 131.299 46.7619H131.303Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3144 46.1988V48.428C74.5536 48.1779 74.8294 48.0528 75.1311 48.0528C75.4805 48.0528 75.7748 48.1852 76.0066 48.4501C76.2383 48.7113 76.356 49.0387 76.356 49.4286C76.356 49.8185 76.2383 50.168 76.0029 50.4292C75.7712 50.6903 75.4732 50.8228 75.1201 50.8228C74.8184 50.8228 74.5499 50.705 74.3144 50.4733V50.7492H73.7148V46.1988H74.3144ZM75.7454 49.4543C75.7454 49.2042 75.6792 48.9982 75.5431 48.84C75.407 48.6782 75.2341 48.5972 75.0281 48.5972C74.8074 48.5972 74.6271 48.6745 74.4873 48.8327C74.3512 48.9872 74.2813 49.1895 74.2813 49.4359C74.2813 49.6824 74.3476 49.8958 74.4837 50.0466C74.6198 50.2011 74.7963 50.282 75.0171 50.282C75.2267 50.282 75.3996 50.2048 75.5357 50.0466C75.6755 49.8884 75.7454 49.6898 75.7454 49.4543Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7167 50.2602L76.5469 48.123H77.2458L78.0404 49.6312L78.7834 48.123H79.464L77.3893 52.173H76.7014L77.7167 50.2565V50.2602Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5912 16.6234L8.76238 21.8874H5.44434L17.2782 0L29.1121 21.8874H25.7941L22.9653 16.6234H11.5912ZM17.2782 5.73486L12.875 14.2286H21.6851L17.2819 5.73486H17.2782Z",
    fill: "url(#paint0_linear_3962_20530)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4503 19.4928H45.5737V21.8875H32.3604V0.89035H35.4503V19.4928Z",
    fill: "url(#paint1_linear_3962_20530)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6697 21.8875H50.5797V3.28508H43.3955V0.89035H60.8502V3.28508H53.666V21.8875H53.6697Z",
    fill: "url(#paint2_linear_3962_20530)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6025 0.89035H77.9152V3.28508H67.6925V9.15972H77.6209V11.5545H67.6925V19.4928H77.9152V21.8875H64.6025V0.89035Z",
    fill: "url(#paint3_linear_3962_20530)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0924 21.8875H94.3439L87.0457 13.0038H85.7619V21.8875H82.6719V0.89035H86.4203C88.6238 0.89035 90.9891 0.919778 92.9608 1.86516C95.0318 2.89516 96.2163 4.87422 96.2163 6.87903C96.2163 9.88808 93.851 12.3932 90.2681 12.7537L98.0924 21.8875ZM85.7655 10.8335H86.7514C89.9076 10.8335 93.3249 10.3332 93.3249 6.98938C93.3249 3.64558 89.6427 3.22991 86.5859 3.22991H85.7655V10.8335Z",
    fill: "url(#paint4_linear_3962_20530)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M101.98 0.537079L118.637 16.4027V0.890219H121.727V22.7518L105.07 6.88625V22.5385H101.98V0.537079Z",
    fill: "url(#paint5_linear_3962_20530)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M131.277 16.6234L128.448 21.8874H125.13L136.964 0L148.798 21.8874H145.48L142.651 16.6234H131.277ZM136.964 5.73486L132.561 14.2286H141.371L136.967 5.73486H136.964Z",
    fill: "url(#paint6_linear_3962_20530)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M155.098 21.8875H152.008V3.28508H144.824V0.89035H162.279V3.28508H155.095V21.8875H155.098Z",
    fill: "url(#paint7_linear_3962_20530)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M165.527 0.89035H178.84V3.28508H168.617V9.15972H178.546V11.5545H168.617V19.4928H178.84V21.8875H165.527V0.89035Z",
    fill: "url(#paint8_linear_3962_20530)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M194.525 4.87376C193.605 3.5642 192.421 2.89471 190.548 2.89471C188.577 2.89471 186.406 4.03506 186.406 5.87433C186.406 7.51864 188.312 8.37942 189.857 8.88338L191.63 9.46827C195.147 10.6381 197.777 12.2824 197.777 15.788C197.777 19.6027 194.293 22.3321 189.853 22.3321C185.843 22.3321 182.72 19.8271 182.194 16.4575L185.317 15.9021C185.284 18.2122 187.455 19.8859 190.118 19.8859C192.781 19.8859 194.687 17.9915 194.687 15.7917C194.687 13.5919 192.549 12.5619 190.412 11.8078L188.702 11.1935C185.873 10.1635 183.313 8.79877 183.313 5.87433C183.313 2.47535 186.862 0.444794 190.611 0.444794C193.373 0.444794 195.639 1.58514 196.989 3.61938L194.525 4.87376Z",
    fill: "url(#paint9_linear_3962_20530)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M184.233 28.6378H1.79513L0 31.9559H195.982L197.777 28.6378H184.233Z",
    fill: "url(#paint10_linear_3962_20530)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M213.205 28.6375L215 25.3194H199.572L197.777 28.6375H213.205Z",
    fill: "url(#paint11_linear_3962_20530)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3962_20530",
    x1: 262.247,
    y1: -46.8389,
    x2: -27.0961,
    y2: 23.1013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3962_20530",
    x1: 263.222,
    y1: -42.8181,
    x2: -26.1249,
    y2: 27.1221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3962_20530",
    x1: 263.748,
    y1: -40.6331,
    x2: -25.5993,
    y2: 29.3071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3962_20530",
    x1: 265.002,
    y1: -35.4427,
    x2: -24.3411,
    y2: 34.4976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3962_20530",
    x1: 266.059,
    y1: -31.0762,
    x2: -23.2887,
    y2: 38.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3962_20530",
    x1: 267.302,
    y1: -25.9301,
    x2: -22.0418,
    y2: 44.0102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3962_20530",
    x1: 268.854,
    y1: -19.5073,
    x2: -20.4891,
    y2: 50.4329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3962_20530",
    x1: 269.347,
    y1: -17.4693,
    x2: -19.9968,
    y2: 52.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3962_20530",
    x1: 270.576,
    y1: -12.3929,
    x2: -18.7716,
    y2: 57.5473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3962_20530",
    x1: 271.572,
    y1: -8.26968,
    x2: -17.7754,
    y2: 61.6707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3962_20530",
    x1: 270.848,
    y1: -11.267,
    x2: -18.4994,
    y2: 58.6733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3962_20530",
    x1: 276.024,
    y1: 10.1454,
    x2: -13.3233,
    y2: 80.0854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAxisAlternates);
export default __webpack_public_path__ + "static/media/NewAxisAlternates.027340f1ac66faa48aef6ff14f286708.svg";
export { ForwardRef as ReactComponent };